import {combineReducers} from '@reduxjs/toolkit'
import noteListSlice from './noteReducer'
import savedSearchSlice from './savedSearchReducer'
import userSlice from './userReducer'

// const rootReducer = combineReducers({
//   savedSearchRoot: savedSearchSlice,
//   notesRoot: noteListSlice,
//   userRoot: userSlice,
//   [apiSlice.reducerPath]: apiSlice.reducer,
// })

const rootReducer = combineReducers({
  savedSearchRoot: savedSearchSlice,
  notesRoot: noteListSlice,
  userRoot: userSlice,
})

export default rootReducer
